import { createStyles, makeStyles, TextField, Theme } from '@material-ui/core';
import React from 'react';
import EditCommonLabel from './EditCommonLabel';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    elementPreview: { marginTop: theme.spacing(4), width: '70%' }
  })
);
interface EditEmailProps {
  onUpdateElementLabel: (e: any) => void;
  label: string;
}

const EditEmail = ({ onUpdateElementLabel, label }: EditEmailProps) => {
  const classes = useStyles();
  return (
    <>
      <EditCommonLabel onChange={onUpdateElementLabel} value={label} />
      <TextField
        type="email"
        className={classes.elementPreview}
        disabled
        placeholder="Sähköpostiosoite"
      />
    </>
  );
};
export default EditEmail;
